import { render, staticRenderFns } from "./YearDropdown.vue?vue&type=template&id=145083aa&scoped=true&"
import script from "./YearDropdown.vue?vue&type=script&lang=ts&"
export * from "./YearDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./YearDropdown.vue?vue&type=style&index=0&id=145083aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145083aa",
  null
  
)

export default component.exports